import { FaCalculator, FaHome, FaMapMarkerAlt } from "react-icons/fa";
import React, { Suspense } from "react";
import dynamic from "next/dynamic";

const Tab = dynamic(() => import("../Tab"), {
  suspense: true,
});

const PropertyDetails = dynamic(() => import("./PropertyDetails"), {
  suspense: true,
});

const Map = dynamic(() => import("./Map"), {
  suspense: true,
});

const Calculator = dynamic(() => import("./Calculator"), {
  suspense: true,
});

interface DetailsProps {
  data: any;
}

const Details: React.FC<DetailsProps> = ({ data }) => {
  return (
    <Suspense fallback={<></>}>
      <Tab
        defaultKey="2"
        tabs={[
          {
            key: "1",
            panel: <Map lng={data.Lng} lat={data.Lat} />,
            title: "Map",
            icons: <FaMapMarkerAlt />,
          },
          {
            key: "2",
            panel: <PropertyDetails data={data} />,
            title: "Property Details",
            icons: <FaHome />,
          },
          {
            key: "3",
            panel: <Calculator />,
            title: "Calculator",
            icons: <FaCalculator />,
          },
        ]}
      />
    </Suspense>
  );
};

export default Details;
